import { render } from "./CalendarPostCard.vue?vue&type=template&id=7a36b039&scoped=true"
import script from "./CalendarPostCard.vue?vue&type=script&lang=js"
export * from "./CalendarPostCard.vue?vue&type=script&lang=js"

import "./CalendarPostCard.vue?vue&type=style&index=0&id=7a36b039&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a36b039"]])

export default __exports__